import SettlementPaymentsDateField from "./SettlementPaymentsDateField";
import SettlementPaymentsModalField from "./SettlementPaymentsModalField";

export default function SettlementPaymentsDateFields({ values, onChange }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <SettlementPaymentsModalField
        label="Payment Date *"
        renderValue={
          <SettlementPaymentsDateField
            fieldName="paymentDate"
            fieldValue={values.paymentDate}
            onChange={onChange}
          />
        }
      />
      <SettlementPaymentsModalField
        label="Deposit Date"
        renderValue={
          <SettlementPaymentsDateField
            fieldName="depositDate"
            fieldValue={values.depositDate}
            onChange={onChange}
          />
        }
      />
      <SettlementPaymentsModalField
        label="CNB Deposit Date"
        renderValue={
          <SettlementPaymentsDateField
            fieldName="cnbDepositDate"
            fieldValue={values.cnbDepositDate}
            onChange={onChange}
          />
        }
      />
    </div>
  );
}
